import { call, select } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { addQuizToRoomFromTemplateRequested } from 'features/quizzes/actions';
import { selectQuizTemplateById } from 'features/quizzes/quizzesSlice';
import { type QuizTemplate } from 'features/quizzes/types';
import { notification } from 'features/notifications/toast/notification';
import i18n from 'i18n';

export function* addQuizToRoomFromTemplateSaga(
  action: ReturnType<typeof addQuizToRoomFromTemplateRequested>
) {
  const { id: templateId } = action.payload;

  const template: QuizTemplate = yield select(selectQuizTemplateById, templateId);
  if (!template) {
    return;
  }

  const questions = template.questions.map((question) => ({
    text: question.text,
    multipleChoices: question.multipleChoices,
    choices: question.choices.map((choice) => ({
      text: choice.text,
      correct: choice.correct,
    })),
  }));

  yield call(SignalingSocket.send, {
    event: 'createQuiz',
    data: {
      templateId,
      title: template.title,
      timeLimitSeconds: template.timeLimitSeconds,
      timingMode: template.timingMode,
      showCorrectAnswers: template.showCorrectAnswers,
      passingScorePercentage: template.passingScorePercentage,
      questions,
    },
  });

  yield call(notification, i18n.t('notifications:quizzes.template_added_to_room'));
}
